import { useNavigate } from 'react-router-dom';
import { Table, Button, Switch, Tag, Tooltip, Popconfirm, message, Modal, Form, Select, DatePicker, Alert, Input, Space, Typography, Divider } from 'antd';

const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;
import { useEffect, useState } from 'react';
import MainLayout from '../../components/MainLayout';
import { routes } from '../../utils/routes.config';
import { DeleteOutlined, EditOutlined, EyeOutlined, PoweroffOutlined, DollarOutlined, PlusOutlined, ShopOutlined, UserOutlined, LockOutlined, CopyOutlined, CheckCircleOutlined } from '@ant-design/icons';
import useFetch from '../../Hooks/FetchData';
import { ApiConfig } from '../../services/ApiConfigs';
import { ApiServices } from '../../services/apiServices';
import planService from '../../services/planService';
import { successMsg, errorMsg } from '../../utils/ShowMessage';
import moment from 'moment';

const Dashboard = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [onboardingForm] = Form.useForm();
    const [planModalVisible, setPlanModalVisible] = useState(false);
    const [onboardingModalVisible, setOnboardingModalVisible] = useState(false);
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const [onboardingData, setOnboardingData] = useState<any>(null);
    const [onboardingLoading, setOnboardingLoading] = useState(false);
    const [selectedStore, setSelectedStore] = useState<any>(null);

    const { data: STORES, error, loading, refetch } = useFetch(ApiConfig.STORES, { trigger: true, });
    const { data: plans } = useFetch(ApiConfig.PLANS_ACTIVE, { trigger: true });

    const [stores, setStores] = useState([] as any);

    useEffect(() => {
        console.log(STORES, "STORES")
        setStores(STORES)
    }, [STORES])


    const toggleStoreStatus = (id: any) => {
        const updatedStores = stores.map(store =>
            store.id === id ? { ...store, status: !store.status } : store
        );
        setStores(updatedStores);
    };

    // const columns = [
    //     {
    //         title: 'Image',
    //         dataIndex: 'image',
    //         key: 'image',
    //         render: (text, record) => (
    //             <img src={record.image} alt={record.name} style={{ width: 100, borderRadius: 5 }} />
    //         )
    //     },
    //     {
    //         title: 'Name',
    //         dataIndex: 'name',
    //         key: 'name',
    //         render: (text) => <strong>{text}</strong>
    //     },
    //     {
    //         title: 'Details',
    //         dataIndex: 'details',
    //         key: 'details'
    //     },
    //     {
    //         title: 'Start Date',
    //         dataIndex: 'startDate',
    //         key: 'startDate'
    //     },
    //     {
    //         title: 'End Date',
    //         dataIndex: 'endDate',
    //         key: 'endDate'
    //     },
    //     {
    //         title: 'Status',
    //         key: 'status',
    //         render: (_, record) => (
    //             <Tag color={record.status ? 'green' : 'red'}>
    //                 {record.status ? 'Enabled' : 'Disabled'}
    //             </Tag>
    //         )
    //     },

    //     {
    //         title: 'Action',
    //         key: 'action',
    //         render: (_, record) => (
    //             <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
    //                 <Tooltip title={record.status ? 'Disable' : 'Enable'}>
    //                     <Button
    //                         shape="circle"
    //                         icon={<PoweroffOutlined />}
    //                         size='small'
    //                         type={record.status ? 'primary' : 'default'}
    //                         onClick={() => toggleStoreStatus(record.id)}
    //                     />
    //                 </Tooltip>

    //                 <Tooltip title="View Orders">
    //                     <Button
    //                         shape="circle"
    //                         size='small'
    //                         icon={<EyeOutlined />}
    //                         onClick={() => navigate(routes.Orders)}
    //                     />
    //                 </Tooltip>

    //                 <Tooltip title="Edit Store">
    //                     <Button
    //                         shape="circle"
    //                         size='small'
    //                         icon={<EditOutlined />}
    //                         onClick={() => console.log('Edit store', record.id)}
    //                     />
    //                 </Tooltip>

    //                 <Tooltip title="Delete Store">
    //                     <Button
    //                         shape="circle"
    //                         size='small'
    //                         icon={<DeleteOutlined />}
    //                         danger
    //                         onClick={() => console.log('Delete store', record.id)}
    //                     />
    //                 </Tooltip>
    //             </div>
    //         )
    //     }
    // ];

    const handleDeleteStore = async (storeId: number) => {
        try {
            await ApiServices('delete', `${ApiConfig.STORES}/${storeId}`);
            message.success('Store deleted successfully');
            refetch()
        } catch (error) {
            message.error('Failed to delete store');
            console.error(error);
        }
    };

    const handleAssignPlan = async (values: any) => {
        try {
            console.log('Form values:', values);
            console.log('Selected store:', selectedStore);
            
            // Validate planId is present
            if (!values.planId) {
                message.error('Please select a plan');
                return;
            }
            
            // Backend will use current time for startDate automatically
            const requestBody = {
                storeId: selectedStore?.id,
                planId: values.planId,
                // Only send endDate if user wants to customize (optional)
                endDate: values.endDate ? values.endDate.format('YYYY-MM-DD') : null,
            };
            
            console.log('Request body:', requestBody);
            
            const response = await planService.assignPlanToStore(requestBody);
            
            if (response?.success) {
                message.success('Plan assigned successfully');
                setPlanModalVisible(false);
                form.resetFields();
                setSelectedStore(null);
                refetch();
            } else {
                message.error(response.message || 'Failed to assign plan');
            }
        } catch (error: any) {
            console.error('Assign plan error:', error);
            message.error(error.message || 'Failed to assign plan');
        }
    };

    const handleOpenPlanModal = (store: any) => {
        setSelectedStore(store);
        setPlanModalVisible(true);
        // Reset form when opening modal
        form.resetFields();
    };

    const handleOpenOnboardingModal = () => {
        setOnboardingModalVisible(true);
        onboardingForm.resetFields();
    };

    const handleOnboardingSubmit = async (values: any) => {
        setOnboardingLoading(true);
        try {
            const payload = {
                name: values.storeName,
                shopUrl: values.shopUrl,
                accessScope: values.accessScope,
                accessToken: values.accessToken,
                details: values.details,
                platformType: values.platformType || 'shopify',
                image: values.image || null,
                adminEmail: values.adminEmail,
                adminPassword: values.adminPassword,
                adminFirstName: values.adminFirstName,
                adminLastName: values.adminLastName,
                adminPhoneNumber: values.adminPhoneNumber,
                adminGender: values.adminGender,
                adminCountry: values.adminCountry,
                adminState: values.adminState,
                adminCity: values.adminCity
            };

            const res = await ApiServices('post', ApiConfig.STORE_ONBOARDING, payload);
            
            if (res.success) {
                setOnboardingData(res.data);
                setOnboardingModalVisible(false);
                setSuccessModalVisible(true);
                onboardingForm.resetFields();
                successMsg("Store onboarded successfully!");
                refetch();
            } else {
                errorMsg(res.message || "Failed to onboard store");
            }
        } catch (error: any) {
            console.error('Onboarding error:', error);
            errorMsg(error.message || "Something went wrong. Please try again.");
        } finally {
            setOnboardingLoading(false);
        }
    };

    const handleCopy = (text: string, label: string) => {
        navigator.clipboard.writeText(text).then(() => {
            successMsg(`${label} copied to clipboard!`);
        }).catch(() => {
            errorMsg("Failed to copy to clipboard");
        });
    };

    const columns = [
        {
            title: 'Image',
            dataIndex: 'image',
            key: 'image',
            render: (_: string, record: any) => {
                const defaultImage = "https://placehold.co/600x400/000000/FFFFFF/png";
                const imageUrl = record.image || defaultImage;

                return (
                    <img
                        src={imageUrl}
                        alt={record.name}
                        style={{ width: 100, borderRadius: 5 }}
                        onError={(e) => {
                            (e.target as HTMLImageElement).src = defaultImage;
                        }}
                    />
                );
            },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text: string) => <strong>{text}</strong>,
        },
        {
            title: 'Store URL',
            dataIndex: 'shopUrl',
            key: 'shopUrl',
            render: (url: string) => (
                <a href={url.startsWith('http') ? url : `https://${url}`} target="_blank" rel="noopener noreferrer">
                    {url}
                </a>
            ),
        },
        {
            title: 'Details',
            dataIndex: 'details',
            key: 'details',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (_: any, record: any) => (
                <Tag color={record.status ? 'green' : 'red'}>
                    {record.status ? 'Enabled' : 'Disabled'}
                </Tag>
            ),
        },
        {
            title: 'Plan',
            key: 'plan',
            render: (_: any, record: any) => {
                // Plan info will be fetched from StorePlan via API
                // For now, show activePlanId if available
                if (record.activePlanId) {
                    return <Tag color="green">Plan Assigned</Tag>;
                }
                return <Tag color="default">No Plan</Tag>;
            },
        },
        {
            title: 'Actions',
            key: 'action',
            render: (_: any, record: any) => (
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                    <Tooltip title="Assign Plan">
                        <Button
                            shape="circle"
                            size="small"
                            icon={<DollarOutlined />}
                            onClick={() => handleOpenPlanModal(record)}
                        />
                    </Tooltip>

                    <Tooltip title={record.status ? 'Disable' : 'Enable'}>
                        <Button
                            shape="circle"
                            size="small"
                            icon={<PoweroffOutlined />}
                            type={record.status ? 'primary' : 'default'}
                            onClick={() => toggleStoreStatus(record.id)}
                        />
                    </Tooltip>

                    <Tooltip title="View Store Details">
                        <Button
                            shape="circle"
                            size="small"
                            icon={<EyeOutlined />}
                            onClick={() => {
                                navigate(`/admin/stores/${record.id}`)
                            }}
                        />
                    </Tooltip>

                    <Tooltip title="Delete Store">
                        <Button
                            shape="circle"
                            size="small"
                            icon={<DeleteOutlined />}
                            danger
                            onClick={() => handleDeleteStore(record.id)}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];

    return (
        <MainLayout>
            <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 style={{ margin: 0 }}>Stores</h2>
                <Button 
                    type="primary" 
                    icon={<PlusOutlined />}
                    onClick={handleOpenOnboardingModal}
                    size="large"
                >
                    Add Store
                </Button>
            </div>
            <Table
                dataSource={stores}
                columns={columns}
                rowKey="id"
                pagination={{ pageSize: 5 }}
                bordered
                loading={loading}
            />

            {/* Plan Assignment Modal */}
            <Modal
                title={`Assign Plan to ${selectedStore?.name || 'Store'}`}
                open={planModalVisible}
                onCancel={() => {
                    setPlanModalVisible(false);
                    form.resetFields();
                    setSelectedStore(null);
                }}
                footer={null}
                width={600}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleAssignPlan}
                >
                    <Alert
                        message="Plan will start immediately"
                        description="The plan will be activated from today. Start date is automatically set to current time."
                        type="info"
                        showIcon
                        style={{ marginBottom: 16 }}
                    />

                    <Form.Item
                        name="planId"
                        label="Select Plan"
                        rules={[
                            { required: true, message: 'Please select a plan' },
                            {
                                validator: (_, value) => {
                                    if (!value) {
                                        return Promise.reject(new Error('Please select a plan'));
                                    }
                                    return Promise.resolve();
                                }
                            }
                        ]}
                    >
                        <Select 
                            placeholder="Select a plan"
                            showSearch
                            optionFilterProp="children"
                            onChange={(value) => {
                                console.log('Plan selected:', value);
                                form.setFieldsValue({ planId: value, endDate: null });
                            }}
                            value={form.getFieldValue('planId')}
                        >
                            {plans?.map((plan: any) => (
                                <Option key={plan.id} value={plan.id}>
                                    {plan.name} - {plan.currencySymbol}{plan.price} 
                                    {plan.planType === 'subscription' ? ` / ${plan.billingPeriod}` : ' (One-Time)'}
                                    {plan.planType === 'one_time' && ' - Lifetime'}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item shouldUpdate={(prevValues, currentValues) => prevValues.planId !== currentValues.planId}>
                        {({ getFieldValue }) => {
                            const selectedPlanId = getFieldValue('planId');
                            const selectedPlan = plans?.find((p: any) => p.id === selectedPlanId);
                            
                            if (selectedPlan?.planType === 'subscription') {
                                return (
                                    <Form.Item
                                        name="endDate"
                                        label="End Date (Optional - Leave empty to auto-calculate based on billing period)"
                                    >
                                        <DatePicker style={{ width: '100%' }} />
                                    </Form.Item>
                                );
                            }
                            
                            if (selectedPlan?.planType === 'one_time') {
                                return (
                                    <Alert
                                        message="One-Time Plan"
                                        description="This is a one-time payment plan with lifetime access. No end date required."
                                        type="success"
                                        showIcon
                                        style={{ marginBottom: 16 }}
                                    />
                                );
                            }
                            
                            return null;
                        }}
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" block>
                            Assign Plan
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            {/* Store Onboarding Modal */}
            <Modal
                title={
                    <Space>
                        <ShopOutlined style={{ color: '#1890ff' }} />
                        <span>Add New Store</span>
                    </Space>
                }
                open={onboardingModalVisible}
                onCancel={() => {
                    setOnboardingModalVisible(false);
                    onboardingForm.resetFields();
                }}
                footer={null}
                width={800}
                style={{ top: 20 }}
            >
                <Form
                    form={onboardingForm}
                    layout="vertical"
                    onFinish={handleOnboardingSubmit}
                    autoComplete="off"
                >
                    <Alert
                        message="Store Information"
                        description="Enter the store details and platform information."
                        type="info"
                        showIcon
                        style={{ marginBottom: 24 }}
                    />

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                        <Form.Item
                            label="Store Name"
                            name="storeName"
                            rules={[{ required: true, message: 'Please enter store name' }]}
                        >
                            <Input prefix={<ShopOutlined />} placeholder="Enter store name" />
                        </Form.Item>

                        <Form.Item
                            label="Shop URL"
                            name="shopUrl"
                            rules={[
                                { required: true, message: 'Please enter shop URL' },
                                { type: 'url', message: 'Please enter a valid URL' }
                            ]}
                        >
                            <Input prefix={<ShopOutlined />} placeholder="https://yourstore.com" />
                        </Form.Item>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                        <Form.Item
                            label="Platform Type"
                            name="platformType"
                            rules={[{ required: true, message: 'Please select platform type' }]}
                            initialValue="shopify"
                        >
                            <Select placeholder="Select platform">
                                <Option value="shopify">Shopify</Option>
                                <Option value="woocommerce">WooCommerce</Option>
                                <Option value="magento">Magento</Option>
                                <Option value="custom">Custom</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="Store Image URL (Optional)"
                            name="image"
                        >
                            <Input placeholder="https://example.com/image.jpg" />
                        </Form.Item>
                    </div>

                    <Form.Item
                        label="Access Scope"
                        name="accessScope"
                        rules={[{ required: true, message: 'Please enter access scope' }]}
                    >
                        <Input placeholder="e.g., read_orders, write_orders" />
                    </Form.Item>

                    <Form.Item
                        label="Access Token"
                        name="accessToken"
                        rules={[{ required: true, message: 'Please enter access token' }]}
                    >
                        <Input.Password placeholder="Enter access token" />
                    </Form.Item>

                    <Form.Item
                        label="Store Details"
                        name="details"
                        rules={[{ required: true, message: 'Please enter store details' }]}
                    >
                        <TextArea rows={3} placeholder="Describe your store..." />
                    </Form.Item>

                    <Divider>Admin Account Information</Divider>

                    <Alert
                        message="Admin Account"
                        description="Create an admin account for this store."
                        type="info"
                        showIcon
                        style={{ marginBottom: 24 }}
                    />

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                        <Form.Item
                            label="First Name"
                            name="adminFirstName"
                            rules={[{ required: true, message: 'Please enter first name' }]}
                        >
                            <Input prefix={<UserOutlined />} placeholder="First Name" />
                        </Form.Item>

                        <Form.Item
                            label="Last Name"
                            name="adminLastName"
                            rules={[{ required: true, message: 'Please enter last name' }]}
                        >
                            <Input prefix={<UserOutlined />} placeholder="Last Name" />
                        </Form.Item>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                        <Form.Item
                            label="Email"
                            name="adminEmail"
                            rules={[
                                { required: true, message: 'Please enter email' },
                                { type: 'email', message: 'Please enter a valid email' }
                            ]}
                        >
                            <Input prefix={<UserOutlined />} placeholder="admin@example.com" />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="adminPassword"
                            rules={[
                                { required: true, message: 'Please enter password' },
                                { min: 6, message: 'Password must be at least 6 characters' }
                            ]}
                        >
                            <Input.Password prefix={<LockOutlined />} placeholder="Password" />
                        </Form.Item>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                        <Form.Item
                            label="Phone Number (Optional)"
                            name="adminPhoneNumber"
                        >
                            <Input placeholder="+1234567890" />
                        </Form.Item>

                        <Form.Item
                            label="Gender (Optional)"
                            name="adminGender"
                        >
                            <Select placeholder="Select gender">
                                <Option value="male">Male</Option>
                                <Option value="female">Female</Option>
                                <Option value="other">Other</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="Country (Optional)"
                            name="adminCountry"
                        >
                            <Input placeholder="Country" />
                        </Form.Item>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                        <Form.Item
                            label="State (Optional)"
                            name="adminState"
                        >
                            <Input placeholder="State" />
                        </Form.Item>

                        <Form.Item
                            label="City (Optional)"
                            name="adminCity"
                        >
                            <Input placeholder="City" />
                        </Form.Item>
                    </div>

                    <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
                        <Button type="primary" htmlType="submit" block loading={onboardingLoading} size="large">
                            <CheckCircleOutlined /> Create Store
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            {/* Success Modal with API Keys */}
            <Modal
                title={
                    <Space>
                        <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 24 }} />
                        <span>Store Created Successfully!</span>
                    </Space>
                }
                open={successModalVisible}
                onOk={() => {
                    setSuccessModalVisible(false);
                    setOnboardingData(null);
                }}
                onCancel={() => {
                    setSuccessModalVisible(false);
                    setOnboardingData(null);
                }}
                okText="Close"
                width={700}
            >
                {onboardingData && (
                    <div>
                        <Alert
                            message="Store onboarded successfully!"
                            description="Please save your API keys securely. You won't be able to see the secret key again."
                            type="success"
                            showIcon
                            style={{ marginBottom: 24 }}
                        />

                        <div>
                            <Title level={5}>Store Information</Title>
                            <div style={{ marginBottom: 16, padding: 12, background: '#f5f5f5', borderRadius: 4 }}>
                                <div style={{ marginBottom: 8 }}>
                                    <Text strong>Store Name: </Text>
                                    <Text>{onboardingData.store.name}</Text>
                                </div>
                                <div>
                                    <Text strong>Shop URL: </Text>
                                    <Text>{onboardingData.store.shopUrl}</Text>
                                </div>
                            </div>

                            <Divider />

                            <Title level={5}>Admin Account</Title>
                            <div style={{ marginBottom: 16, padding: 12, background: '#f5f5f5', borderRadius: 4 }}>
                                <Text strong>Email: </Text>
                                <Text>{onboardingData.adminUser.email}</Text>
                            </div>

                            <Divider />

                            <Title level={5}>API Keys</Title>
                            <div style={{ marginBottom: 16 }}>
                                <div style={{ marginBottom: 12, padding: 12, background: '#f5f5f5', borderRadius: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>
                                        <Text strong>API Key: </Text>
                                        <Tag color="blue">{onboardingData.apiKeys.apiKey}</Tag>
                                    </div>
                                    <Button
                                        type="text"
                                        size="small"
                                        icon={<CopyOutlined />}
                                        onClick={() => handleCopy(onboardingData.apiKeys.apiKey, 'API Key')}
                                    />
                                </div>
                                <div style={{ padding: 12, background: '#f5f5f5', borderRadius: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>
                                        <Text strong>Secret Key: </Text>
                                        <Tag color="red">{onboardingData.apiKeys.secretKey}</Tag>
                                    </div>
                                    <Button
                                        type="text"
                                        size="small"
                                        icon={<CopyOutlined />}
                                        onClick={() => handleCopy(onboardingData.apiKeys.secretKey, 'Secret Key')}
                                    />
                                </div>
                            </div>
                            <Alert
                                message={onboardingData.apiKeys.warning}
                                type="warning"
                                showIcon
                            />
                        </div>
                    </div>
                )}
            </Modal>
        </MainLayout>
    );
};

export default Dashboard;
